/* eslint-disable camelcase */
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

// Need to use snake_case for utm parameters
export interface UtmDataProps {
  utm_source: string
  utm_medium: string
  utm_campaign: string
  utm_term: string
  utm_content: string
  utm_referral: string
}
export const utmDefault: UtmDataProps = {
  utm_source: '',
  utm_medium: '',
  utm_campaign: '',
  utm_term: '',
  utm_content: '',
  utm_referral: '',
}

const useTrackUtmParams = () => {
  const router = useRouter()
  const [utmParams, setUtmParams] = useState(utmDefault)

  useEffect(() => {
    const utm_source = (router.query.utm_source as string) || ''
    const utm_medium = (router.query.utm_medium as string) || ''
    const utm_campaign = (router.query.utm_campaign as string) || ''
    const utm_term = (router.query.utm_term as string) || ''
    const utm_content = (router.query.utm_content as string) || ''
    const utm_referral = (router.query.utm_referral as string) || ''

    setUtmParams({
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      utm_referral,
    })
  }, [
    router.query.utm_campaign,
    router.query.utm_content,
    router.query.utm_medium,
    router.query.utm_referral,
    router.query.utm_source,
    router.query.utm_term,
  ])

  return { utmParams }
}

export default useTrackUtmParams
